<ng-container *ngIf="tutorialHighlight?.visible">
  <div #overlay style="position: fixed; left: 0; top: 0; right: 0; bottom: 0; z-index: 1030;">
    <div (click)="hideOverlay()" class="cutoutOverlay" [style.left.px]="leftOverlay?.left" [style.top.px]="leftOverlay?.top"
         [style.right.px]="leftOverlay?.right" [style.bottom.px]="leftOverlay?.bottom"></div>
    <div (click)="hideOverlay()" class="cutoutOverlay" [style.left.px]="topOverlay?.left" [style.top.px]="topOverlay?.top"
         [style.right.px]="topOverlay?.right" [style.height.px]="topOverlay?.height"></div>
    <div (click)="hideOverlay()" class="cutoutOverlay" [style.left.px]="rightOverlay?.left" [style.top.px]="rightOverlay?.top"
         [style.right.px]="rightOverlay?.right" [style.bottom.px]="rightOverlay?.bottom"></div>
    <div (click)="hideOverlay()" class="cutoutOverlay" [style.left.px]="bottomOverlay?.left" [style.top.px]="bottomOverlay?.top"
         [style.right.px]="bottomOverlay?.right" [style.bottom.px]="bottomOverlay?.bottom"></div>
  </div>
</ng-container>
